<template>
  <section>
    <div class="container">
      <app-header title="提现"/>
      <div class="content">
        <div class="choose">提现到微信钱包</div>
        <div class="allwi">
          <div>提现金额</div>
          <span class="hintwi">（提现金额为100的整数倍）</span>
        </div>
        <div class="money">
          <span class="money-icon">￥</span>
          <input type="text" v-model="form.money" class="input-money" placeholder="请输入提现金额" maxlength="10" onkeyup="value=value.replace(/[^\d]/g,'')">
        </div>
        <div class="row-cash">
          <div class="name" style="margin-top: 15px;margin-bottom: 10px">* 申请货款订单号</div>
          <input type="text" class="input-cash" v-model="form.orderNo">
        </div>
        <div class="row-cash">
          <div class="name" style="margin-top: 15px;margin-bottom: 10px">* 申请提现微信号</div>
          <input type="text" class="input-cash" v-model="form.weixinNo">
        </div>
        <div class="row-cash">
          <div class="name" style="margin-top: 15px;margin-bottom: 10px">* 对应订单送货日期</div>
          <!--<input type="text" class="input-cash" v-model="form.deliveryTime"  @click="showPicker = true">-->
          <div type="text" class="input-cash" v-text="form.deliveryTime"  @click="showPicker = true"></div>
        </div>
        <van-popup v-model="showPicker" position="bottom">
          <van-datetime-picker
            :formatter="formatter"
            type="datehour"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>
        <div>
          <div class="name" style="margin-top: 15px;margin-bottom: 10px">申请原因</div>
          <textarea class="synopsis" v-model="form.reason" maxlength="200" placeholder="请填写（200字以内）"></textarea>
        </div>
        <div>
          <div class="name" style="margin-top: 15px;margin-bottom: 10px">备注</div>
          <textarea class="synopsis" v-model="form.remark" maxlength="200" placeholder="请填写（200字以内）"></textarea>
        </div>
      </div>
      <!--产品信息-->
      <div class="main">
        <div class="title">
          <div class="text">请填写产品信息：</div>
        </div>
        <div class="table_box_big">
          <div class="table_box">
            <table class="table" border="0" width="100%" cellspacing="10"  style="table-layout:fixed">
              <!-- 表头 -->
              <thead>
              <tr>
                <th>*产品名称</th>
                <th>*产品型号</th>
                <th>*封装/规格</th>
                <th>品牌</th>
                <th>数量</th>
                <th>单价</th>
                <th>金额</th>
                <th>操作</th>
              </tr>
              </thead>
            </table>
            <div class="table_tbody_box">
              <table class="table"  border="0" width="100%" cellspacing="10"  style="table-layout:fixed">
                <tbody>
                <tr v-for="(item,index) in cashItems" :key="index">
                  <td><page-input v-model="item.name" class="input"/></td>
                  <td><page-input v-model="item.model" class="input"/></td>
                  <td><page-input v-model="item.packages" class="input"/></td>
                  <td><page-input v-model="item.brand" class="input"/></td>
                  <td><page-input v-model="item.number" class="input"/></td>
                  <td><page-input v-model="item.price" class="input"/></td>
                  <td><page-input v-model="item.total" class="input"/></td>
                  <td>
                    <div @click="remove(index)" style="display: flex;flex-direction: row;align-items: center;justify-content: center">
                      <img src="@/assets/del.png" alt="" width="16" height="16">
                      <span style="margin-left: 10px">移除</span>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="tip">左右滑动查看更多</div>
        <div style="margin: 5px 0">
          <div @click="add" style="width: 30%;display: flex;flex-direction: row;justify-content: center;align-items: center;padding: 8px;">
            <img src="@/assets/addRed.png" alt="" width="16" height="16">
            <span style="margin-left: 8px">添加</span>
          </div>
        </div>
      </div>

      <div class="submit" @click="submit">提现</div>
    </div>

  </section>
</template>

<script>
  import { saveCash } from '@/api/mine/cash.js'
  import { getCurtUser } from '@/api/login/index.js'
  export default {
    name: "withdraw",
    data() {
      return {
        showPicker: false,
        active: '0',
        user : null,
        cashItems: [],
        form: {
          money: '',
          openId: '',
          uid : '',
          username : '',
          type : 0, //提现渠道：{0：微信，1支付宝}
        }
      }
    },
    created(){
      var user = localStorage.getItem('storeInfo')
      if (user){
        this.user = JSON.parse(user)
      }
    },
    methods: {
      // 选项格式化函数
      formatter (type, value) {
        if (type === 'year') {
          return `${value}年`
        } else if (type === 'month') {
          return `${value}月`
        } else if (type === 'day') {
          return `${value}日`
        } else if (type === 'hour') {
          return `${value}时`
        } else if (type === 'minute') {
          return `${value}分`
        } else if (type === 'second') {
          return `${value}秒`
        }
        return value
      },
      onConfirm(val){
        console.log(val)
        let year = val.getFullYear()
        let month = val.getMonth() + 1
        let day = val.getDate()
        let hour = val.getHours()
        let minute = val.getMinutes()
        let second = val.getSeconds()
        if (month >= 1 && month <= 9) { month = `0${month}` }
        if (day >= 1 && day <= 9) { day = `0${day}` }
        if (hour >= 0 && hour <= 9) { hour = `0${hour}` }
        if (minute >= 0 && minute <= 9) { minute = `0${minute}` }
        if (second >= 0 && second <= 9) { second = `0${second}` }
        this.form.deliveryTime = `${year}-${month}-${day} ${hour}:${minute}:${second}`
        this.showPicker = false
      },
      remove(index){
        this.cashItems.splice(index,1)
      },
      add() {
        this.cashItems.push({name : '',model : '',packages : '',brand : '',number : '',price: '',total: ''})
      },
      submit(){
        if (!localStorage.getItem("openid")) {
          this.$toast.fail('openid不存在')
          return
        }
        if (!this.form.weixinNo) {
          this.$toast.fail('请输入微信号')
          return
        }
        if (!this.form.orderNo) {
          this.$toast.fail('请输入订单号')
          return
        }
        if (!this.form.deliveryTime) {
          this.$toast.fail('请输入送货日期')
          return
        }
        if (!this.form.money) {
          this.$toast.fail('请输入提现金额')
          return
        }
        if (this.cashItems.length <= 0){
          this.$toast.fail('请填写货物信息')
          return;
        }
        if (parseInt(this.form.money) < 100) {
          this.$toast.fail('金额要满100才能提现哦')
          return
        } else if ((parseInt(this.form.money)) % 100 != 0) {
          this.$toast.fail('只能按100的整数提现')
          return
        }
        this.form.uid = this.user.id
        this.form.username = this.user.nickName
        this.form.acount = localStorage.getItem("openid")
        this.form.cashItems = this.cashItems
        saveCash(this.form).then(res => {
          if (res.success) {
            this.$toast.success('提现请求已提交，等待平台管理员审核')
            this.$router.go(-1);
          }else{
            this.$toast.fail(res.msg)
          }
        })
      },
      detail(){
        this.$router.push("/cashDetail")
      },
      go(){
        this.$router.go(-1);
      },
    }
  }
</script>

<style lang="scss" scoped>
  .synopsis{
    width:100%;
    height:150px;
    background:rgba(255,255,255,1);
    border:1px solid rgba(243,243,243,1);
    border-radius:6px;
    padding: 10px;
    box-sizing: border-box;
  }
  .row-cash{
    width: 100%;
    box-sizing: border-box;
  }
  .input-cash {
    width: 100%;
    height: 40px;
    line-height: 20px;
    border: 1px solid rgba(243, 243, 243, 1);
    border-radius: 4px;
    padding: 10px 10px;
    font-size: 16px;
    font-weight: 400;
    margin-top: 8px;
    box-sizing: border-box;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .input-money{
    width:100%;
    height:40px;
    border-radius:4px;
    padding: 10px;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 42px;
    color: #333333;
  }
  .container{
    padding-top: 50px;
    .main{
      padding: 0 12px;
      .title{
        display: flex;
        margin-top: 15px;
        margin-bottom: 15px;
        .text{
          height:22px;
          font-size:16px;
          font-weight:bold;
          line-height:21px;
          color:rgba(51,51,51,1);
        }
        .zhuyi{
          margin-top: 6px;
          height:14px;
          font-size:10px;
          font-weight:400;
          line-height:14px;
          color:rgba(254,0,59,1);
        }
      }
      .tip{
        height:21px;
        font-size:12px;
        font-weight:bold;
        line-height:21px;
        color:rgba(254,0,59,1);
      }
      .table_box_big{
        overflow: scroll;
        width: 100%;
        /*overflow-x: scroll;*/
        /*overflow-y: hidden;*/
        position: relative;
        min-height: 100px;
        height: auto;
      }
      .table_box{
        /*overflow: hidden;*/
        /*position: absolute;*/
      }
      .table_tbody_box{
        /*height: 400px;*/
        /*overflow: scroll;*/
      }
      table thead tr th{
        width:100px;
        height:30px;
        text-align: center;
        word-break: keep-all;
        padding: 2px 10px;
        font-size:13px;
        font-weight:400;
        color:rgba(102,102,102,1);

      }
      table tbody tr td{
        width:100px;
        height:30px;
        line-height: 30px;
        border: 1px solid #eeeeee;
        text-align: center;
        word-break: keep-all;
        padding: 2px 10px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        font-size:13px;
        font-weight:400;
        color:rgba(102,102,102,1);
        //border:#CCCCCC 1px solid;
        .input{
          width:80px;
          border: none;
          padding: 0;
        }
      }

    }
    .head{
      background-color: #F3F3F3;
      height:44px;
      line-height: 44px;
      opacity:1;
      display: flex;
      justify-content: space-between;
    }
    .content{
      padding: 12px;
      .rehint{
        padding: 22px;
        height:18px;
        font-size:13px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:18px;
        color:rgba(255,255,255,1);
        opacity:1;
      }
      .reprice{
        padding: 22px;
        height:40px;
        font-size:33px;
        font-family:DIN;
        font-weight:bold;
        line-height:40px;
        color:rgba(255,255,255,1);
        opacity:1;
      }
      .choose{
        width: 100%;
        height:20px;
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:20px;
        color:rgba(51,51,51,1);
        text-align: center;
        padding: 22px;
        box-sizing: border-box;
      }
      .allwi{
        display: flex;
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:20px;
        color:rgba(51,51,51,1);
        opacity:1;
        margin-top: 48px;
        margin-bottom: 34px;
        .hintwi{
          font-size:12px;
          font-family:PingFang SC;
          font-weight:400;
          line-height:17px;
          color:rgba(254,0,59,1);
          opacity:1;
        }
      }
      .allea{
        display: flex;
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:20px;
        opacity:1;
        margin-top: 6px;
        .all{
          font-size:16px;
          color: #0DC92C;
        }
      }
      .eahint{
        font-size:12px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:17px;
        color:rgba(254,0,59,1);
        opacity:1;
        margin-top: 6px;
        margin-bottom: 70px;
      }
      .money-icon{
        width: 30px;
        height: 42px;
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: bold;
        line-height: 42px;
        color: #333333;
        opacity: 1;

      }
      .money{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
        font-weight: bold;
        border-bottom: 1px solid #ebedf0;
        padding: 5px;
      }
    }
  }
  .submit-active{
    height:40px;
    width: 95%;
    background: #C7C7C7;
    opacity:1;
    border-radius:4px;
    color: #ffffff;
    margin: auto;
    text-align: center;
    line-height: 40px;
  }
  .submit{
    height:40px;
    width: 95%;
    background:linear-gradient(0deg,rgba(244,4,66,1) 0%,rgba(226,23,75,0.73) 100%);
    opacity:1;
    border-radius:4px;
    color: #ffffff;
    margin: auto;
    text-align: center;
    line-height: 40px;
  }

</style>



// WEBPACK FOOTER //
// src/views/business/cash/index.vue